import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/Button';
import { CopyIcon } from '@/components/icons/CopyIcon';
import { Textarea } from '@/components/Textarea';

type Props = {
  title?: string;
  shareText: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** コピー成功後に呼ばれる（トースト表示などに利用） */
  onCopied?: () => void;
};

export default function ShareContentDialog({
  title = '共有用情報をコピー',
  shareText,
  open,
  onOpenChange,
  onCopied,
}: Props) {
  const handleCopy = () => {
    if (!shareText) {
      alert('共有可能なコンテンツがありません');
      return;
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(shareText).then(() => {
        onOpenChange(false);
        onCopied?.();
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full max-w-lg rounded-sm border border-solid border-gray-200">
        <div className="border-b border-solid border-gray-200 p-lg">
          <DialogTitle>{title}</DialogTitle>
        </div>
        <div className="px-lg py-4">
          <Textarea
            readOnly
            value={shareText || ''}
            rows={shareText.split('\n').length + 2}
            placeholder="共有可能なコンテンツがありません"
            className="max-h-[50vh] w-full resize-none bg-gray-50 p-3 text-sm leading-relaxed"
          />
        </div>
        <div className="flex justify-end border-t border-solid border-gray-200 px-lg pt-4 pb-lg">
          <Button
            color="primary"
            size="sm"
            onClick={handleCopy}
            disabled={!shareText}
            className="flex items-center gap-1"
          >
            <CopyIcon className="size-icon-xxs" />
            コピーして閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
